"use client";

import { Show, SignInButton } from "@clerk/tanstack-react-start";
import { Link } from "@tanstack/react-router";

import { Button } from "#/components/ui/button";
import { cn } from "#/lib/utils";

export function PremiumSubscribeActions({ className }: { className?: string }) {
  return (
    <div className={cn("flex flex-col gap-3", className)}>
      <Show when="signed-in">
        <Button
          variant="premium"
          size="lg"
          className="w-full"
          nativeButton={false}
          render={<a href="/api/billing/checkout" />}
        >
          Subscribe
        </Button>
      </Show>
      <Show when="signed-out">
        <SignInButton mode="modal">
          <Button size="lg" className="w-full">
            Sign in to subscribe
          </Button>
        </SignInButton>
        <Button
          variant="outline"
          size="lg"
          className="w-full"
          nativeButton={false}
          render={<Link to="/" />}
        >
          Back to today&apos;s maps
        </Button>
      </Show>
    </div>
  );
}
